import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { useEffect, useState, useContext } from 'react';
import { collection, getDocs } from "firebase/firestore"; 
import { db } from "../App"
import { GameContext } from '../context/globalContext';

export default function Answer() {
    const [songNames, setSongNames] = useState([])
    const [answer, setAnswer] = useState('')
    const [submitted, setsubmitted] = useState(false)
    const [autocompleteOpen, setAutocompleteOpen] = useState(false)

    const {currentSong, score, setScore, setAnswerContext, songsContext} = useContext(GameContext)

    useEffect(() => {
        
        if(!songsContext){
            console.log('NO CACHE')
        }else{
            songsContext.sort(function (a, b) {
                if (a.Name > b.Name) {
                    return 1;
                }
                if (a.Name < b.Name) {
                    return -1;
                }
                // a must be equal to b
                return 0;
            })
            setSongNames(songsContext)
        }

    }, [songsContext])

    useEffect(() => {
      setAnswer('')
    
    }, [currentSong])
    

    useEffect(() => {
        /* if(answer === currentSong && submitted){
            setScore(score+1)
        } */
        setAnswerContext(answer)
    }, [answer])

    function submitAnswer(target) {
        console.dir(target)
        setsubmitted(true)
        let answer
        if(target.tagName === "INPUT"){
            answer = target.value
        }else if(target.tagName === "LI"){
            answer = target.innerHTML
        }
        setAnswer(answer)
    }

    return (
        <div className="answer">
            {/* <div>{`Answer: '${answer}'`}</div>
            <div>{`Current Song: ${currentSong}`}</div>
            <div>{`submitted answer: ${submitted}`}</div> */}
            <Autocomplete
                freeSolo
                id="free-solo-2-demo"
                disableClearable
                blurOnSelect
                options={songNames}
                //groupBy={(song) => song.Artist}
                getOptionLabel={(song) => `${song.Name} by ${song.Artist}`}
                inputValue={answer}
                open={answer.length > 0 && autocompleteOpen}
                onFocus={() => setAutocompleteOpen(true)}
                onBlur={() => setAutocompleteOpen(false)}
                onInputChange={(event, newInputValue) => {
                    if (newInputValue.trim() != "undefined by undefined") {
                        setAnswer(newInputValue);
                    }
                }}
                onClose={(e) => {
                    submitAnswer(e.target)
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        placeholder='Type your answer here'
                        InputProps={{
                            ...params.InputProps,
                            type: 'search',
                        }}
                    />
                )}
            />
        </div>
    );
  }